// Single source of truth for the legacy frontend purchase events dispatched on
// the purchase success page (see entrypoints/purchase-success.js).
//
// PostHog purchase tracking is now owned by the backend (PurchaseEventsJob sends
// `purchase` / `upsell_or_bundle_purchase`), so these events are filtered out of
// the PostHog plugin (see posthog-analytics.js) while still flowing to the other
// analytics plugins (google-ecommerce derives its GA `purchase` action from
// 'Purchase Succeeded'; fb-pixel is unaffected).
//
// Both the dispatch list and the filter are derived from the definitions below,
// so renaming an event updates both at once — the filter cannot silently drift
// from what is actually dispatched.

// Ordered exactly as dispatched on the success page. Each entry knows how to
// render its dispatched name for a given plan id, and how to recognise itself.
const PURCHASE_EVENTS = [
  {
    build: () => 'Purchase Succeeded',
    matches: (event) => event === 'Purchase Succeeded',
  },
  {
    build: (planId) => `Purchased plan_id: ${planId}`,
    matches: (event) => event.startsWith('Purchased plan_id: '),
  },
  {
    build: (planId) => `ppid_${planId.replaceAll('-', '')}`,
    matches: (event) => event.startsWith('ppid_'),
  },
  {
    build: () => 'Purchased in pay-hammer',
    matches: (event) => event === 'Purchased in pay-hammer',
  },
];

// The legacy purchase event names to dispatch for a given plan id.
export function purchaseEventNames(planId) {
  return PURCHASE_EVENTS.map((definition) => definition.build(planId));
}

// Whether an event is one of the legacy frontend purchase events.
export function isPurchaseEvent(event) {
  return PURCHASE_EVENTS.some((definition) => definition.matches(event));
}
